<template>
  <v-card>
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-card-title>
          {{ currentSurvey.producer_name }}
        </v-card-title>
        <v-card-subtitle mb-0>
          {{
            currentSurvey.commercial_person_name +
              " - " +
              currentSurvey.territory_description
          }}
        </v-card-subtitle>
        <v-toolbar>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            v-model="selectedCrop"
            @change="cropSelected($event)"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            :loading="isLoadingCampaign"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            return-object
            v-model="selectedCampaign"
            @change="campaignSelected($event)"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
        </v-toolbar>
        <!-- table header pagination and add button -->
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ activationEvents }">
              <v-btn
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="activationEvents"
                @click="addNew"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Agregar</span>
          </v-tooltip>
        </div>
        <!-- data table -->
        <v-data-table
          dense
          v-bind:page="page"
          :pageCount="this.pageCount"
          :loading="loading"
          :headers="headers"
          :items="items"
          :itemsPerPage="itemsPerPage"
          :serverItemsLength="serverItemsLength"
          :options.sync="options"
          @click:row="itemSelected($event, false)"
        >
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer
              :pagination="pagination"
              :options="options"
              @update:options="updateOptions"
            />
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-show="item.campaign_current === 'True'"
              small
              class="mr-2"
              @click.stop="itemSelected(item, true)"
            >
              mdi-pencil
            </v-icon>
            <v-icon v-show="canDelete" small @click.stop="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
    <!-- add/edit survey campaign -->
    <survey-campaign-edit
      v-if="showEdit"
      :show="showEdit"
      :currentSurvey="currentSurvey"
      :currentSurveyCampaign="currentItem"
      :cropItems="cropItems"
      :initialMode="editMode"
      @cancel="editCanceled"
      @saved="editSaved"
    >
    </survey-campaign-edit>
  </v-card>
</template>
<script>
import DataSurvey from "@/components/clon/DataSurvey.js";
import SurveyCampaignEdit from "@/components/SurveyCampaignEdit.vue";

export default {
  name: "SurveyCampaign",

  components: {
    SurveyCampaignEdit
  },

  props: [
    "currentSurvey",
    "useDefaults",
    "parentFilterCrop",
    "parentFilterCampaign"
  ],

  data() {
    return {
      currentItem: null,
      cropItems: [],
      campaignItems: [],
      campaigns: [],
      filterCrop: null,
      selectedCrop: null,
      filterCampaign: null,
      selectedCampaign: null,
      isLoadingCampaign: false,
      loading: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 100,
      options: {},
      items: [],
      survey: new DataSurvey(this.$bRoot),
      headers: [
        { text: "Cultivo", value: "crop_description", sortable: false },
        { text: "Campaña", value: "campaign_code", sortable: false },
        { text: "Hectáreas", value: "hectare", sortable: false },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      canEdit: true,
      canDelete: false,
      title: null,
      showEdit: false,
      editMode: ""
    };
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI(reset) {
      try {
        const { page, itemsPerPage } = this.options;
        let pageNumber = reset ? 1 : page;
        this.loading = true;

        let res = await this.survey.getSurveyCampaigns(
          this.currentSurvey.survey_id,
          this.filterCrop ? this.filterCrop.id : null,
          this.filterCampaign ? this.filterCampaign.id : null
        );
        if (this.$bRoot.errors) {
          throw "Error recuperando datos";
        }
        if (res) {
          this.items = res.data.results;
          this.serverItemsLength = res.data.count;
          this.page = pageNumber;
          this.pageCount = Math.ceil(res.data.count / itemsPerPage);
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    cropSelected(crop) {
      this.filterCrop = crop;
      this.readDataFromAPI(true);
    },

    campaignSelected(campaign) {
      this.filterCampaign = campaign;
      this.readDataFromAPI(true);
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "cropAutocomplete":
          this.filterCrop = null;
          this.$emit("useDefaults", false);
          break;
        case "campaignAutocomplete":
          this.filterCampaign = null;
          break;
      }
      this.readDataFromAPI();
    },

    itemSelected(item, edit) {
      if (edit) {
        this.currentItem = item;
        this.editMode = "edit";
        this.showEdit = true;
      }
    },

    editCanceled() {
      this.showEdit = false;
    },

    editSaved() {
      this.showEdit = false;
      this.readDataFromAPI(true);
    },

    addNew() {
      this.currentItem = this.survey.campaignInitialize(
        this.currentSurvey,
        this.filterCrop,
        this.filterCampaign
      );
      this.editMode = "new";
      this.showEdit = true;
    }
  },

  watch: {
    options: {
      handler() {
        this.readDataFromAPI(false);
      }
    },
    deep: true
  },

  async mounted() {
    //crops
    let crops = await this.survey.getCrops();
    this.cropItems = crops.data.results;

    //Parent Filter Crop
    if (this.parentFilterCrop) {
      this.filterCrop = this.parentFilterCrop;
      this.selectedCrop = this.filterCrop.url;
    } else {
      //Default Crop
      if (this.useDefaults) {
        let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
        if (defaultCropId > 0) {
          let index = crops.data.results.findIndex(
            crop => crop.id === defaultCropId
          );
          if (index !== -1) {
            this.filterCrop = crops.data.results[index];
            this.selectedCrop = crops.data.results[index].url;
          }
        }
      }
    }

    //campaigns
    let campaigns = await this.survey.getCampaigns();
    this.campaignItems = campaigns.data.results;

    //Parent filter Campaign
    if (this.parentFilterCampaign) {
      this.filterCampaign = this.parentFilterCampaign;
      this.selectedCampaign = this.filterCampaign.url;
    }
    this.title =
      this.currentSurvey.producer_name +
      " - " +
      this.currentSurvey.commercial_person_name +
      " - " +
      this.currentSurvey.territory_description;

    this.readDataFromAPI(true);
  }
};
</script>
